import {useEffect} from "react";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {connect} from 'react-redux';
import Navbar from "../components/navigation/Navbar";
import Footer from "../components/navigation/Footer";
import {get_locations} from "../redux/actions/location";
import Category from '../components/home/category';
import {refresh_quantity_cart} from "../redux/actions/carrito";

const Layout = (props) => {
    useEffect(() => {
        if (props.locations.length === 0 && props.token) {
            props.get_locations();
            props.refresh_quantity_cart();
        }
    }, []);

    return (
        <div>
            <Navbar/>
            <ToastContainer autoClose={5000}/>
            <Category/>
            {props.children}
            <Footer/>
        </div>
    )
}

const mapStateToProps = state => ({
    locations: state.Location.locations,
    token: state.Auth.token,
})

export default connect(mapStateToProps, {
    get_locations, refresh_quantity_cart
})(Layout)
